// ══════════════════════════════════════════════════════════════════════
//  IFR — IYANNA FOUNDATION RATING
//  Injini rasmi ya rating. Kanuni zake ni za wazi na haziwezi kubadilika
//  kimyakimya: kila kitu hapa ni hesabu tupu, hakuna nasibu, hakuna bonus.
//
//  KANUNI ZA MSINGI
//   1. Michezo ya ana kwa ana pekee, ndani ya tukio lililosajiliwa.
//   2. Hakuna pointi za bure. Hakuna bonus ya mahudhurio. Hakuna bot.
//   3. Michezo yote ya mwezi inahesabiwa dhidi ya rating ya MWANZO wa
//      mwezi — si mchezo baada ya mchezo. Hivyo mtu hawezi kupanda kwa
//      siku moja kwa kupanga wapinzani.
//   4. Kila mchezo unahifadhiwa milele. Rating zote zinaweza kuhesabiwa
//      upya kutoka mwanzo wakati wowote.
// ══════════════════════════════════════════════════════════════════════

export const IFR_FLOOR = 1000;          // sakafu ya rating rasmi
export const MIN_GAMES_FOR_RATING = 5;  // michezo ya chini ya kupata rating ya kwanza
export const RATING_DIFF_CAP = 400;     // kanuni ya pointi 400

// ── K-FACTOR ────────────────────────────────────────────────────────────
// Anayeanza anasogea kwa kasi (rating yake bado haijulikani vizuri);
// aliyefika juu anasogea polepole (rating yake tayari ni sahihi).
export function kFactor({ rating, gamesRated, age }) {
  if (gamesRated < 30) return 40;                 // bado anajengwa
  if (age && age < 18 && rating < 2300) return 40; // vijana wanakua haraka
  if (rating < 2400) return 20;
  return 10;
}

export const K_TABLE = [
  { when: 'Michezo chini ya 30', k: 40 },
  { when: 'Chini ya miaka 18 na rating chini ya 2300', k: 40 },
  { when: 'Rating chini ya 2400', k: 20 },
  { when: 'Rating 2400 na zaidi', k: 10 },
];

// ── EXPECTED SCORE ──────────────────────────────────────────────────────
// Nafasi ya kushinda kulingana na tofauti ya rating (formula ya Elo).
export function expectedScore(rating, opponentRating) {
  const diff = clampDiff(opponentRating - rating);
  return 1 / (1 + Math.pow(10, diff / 400));
}

// Kanuni ya pointi 400: tofauti kubwa kuliko 400 inahesabiwa kama 400.
// Inazuia mchezaji mkubwa kuchuma pointi kwa kucheza na wanaoanza.
export function clampDiff(diff) {
  return Math.max(-RATING_DIFF_CAP, Math.min(RATING_DIFF_CAP, diff));
}

// ── HESABU YA MCHEZO MMOJA ──────────────────────────────────────────────
export function gameChange({ rating, opponentRating, score, k }) {
  const exp = expectedScore(rating, opponentRating);
  return {
    expected: Math.round(exp * 1000) / 1000,
    score,
    change: k * (score - exp),
  };
}

// ── HESABU YA KIPINDI KIZIMA (rating period) ────────────────────────────
// games: [{ opponentRating, score }]  — score: 1 ushindi, 0.5 sare, 0 kushindwa
export function periodChange({ rating, gamesRated, age, games }) {
  const k = kFactor({ rating, gamesRated, age });
  let total = 0;
  const detail = games.map(g => {
    const r = gameChange({ rating, opponentRating: g.opponentRating, score: g.score, k });
    total += r.change;
    return { ...g, ...r, k };
  });
  const newRating = Math.max(IFR_FLOOR, Math.round(rating + total));
  return { k, totalChange: Math.round(total), newRating, detail };
}

// ── JEDWALI LA dp — tofauti ya rating kutokana na asilimia ya pointi ────
// Hili ndilo jedwali linalotumika kuhesabu rating ya kwanza na
// performance rating. Ni jedwali lilelile la kimataifa (FIDE table 8.1a).
const DP_TABLE = {
  1.00: 800, 0.99: 677, 0.98: 589, 0.97: 538, 0.96: 501, 0.95: 470,
  0.94: 444, 0.93: 422, 0.92: 401, 0.91: 383, 0.90: 366, 0.89: 351,
  0.88: 336, 0.87: 322, 0.86: 309, 0.85: 296, 0.84: 284, 0.83: 273,
  0.82: 262, 0.81: 251, 0.80: 240, 0.79: 230, 0.78: 220, 0.77: 211,
  0.76: 202, 0.75: 193, 0.74: 184, 0.73: 175, 0.72: 166, 0.71: 158,
  0.70: 149, 0.69: 141, 0.68: 133, 0.67: 125, 0.66: 117, 0.65: 110,
  0.64: 102, 0.63: 95, 0.62: 87, 0.61: 80, 0.60: 72, 0.59: 65,
  0.58: 57, 0.57: 50, 0.56: 43, 0.55: 36, 0.54: 29, 0.53: 21,
  0.52: 14, 0.51: 7, 0.50: 0,
};

// Jedwali linajengwa upya kwa funguo za maandishi ("0.75") ili kutafuta
// kusiwe na tatizo la desimali.
const DP = {};
Object.entries(DP_TABLE).forEach(([k, v]) => { DP[Number(k).toFixed(2)] = v; });

export function dp(percentage) {
  const p = Math.max(0, Math.min(1, percentage));
  if (p >= 0.5) {
    return DP[p.toFixed(2)] ?? 0;
  }
  return -(DP[(1 - p).toFixed(2)] ?? 0);
}

// ── PERFORMANCE RATING ──────────────────────────────────────────────────
// Rating ambayo matokeo yako yanaonyesha ulicheza kama nayo kwenye tukio.
// Rp = wastani wa rating za wapinzani + dp(asilimia ya pointi)
export function performanceRating(games) {
  if (!games.length) return null;
  const avgOpp = games.reduce((a, g) => a + g.opponentRating, 0) / games.length;
  const pts = games.reduce((a, g) => a + g.score, 0);
  const pct = pts / games.length;
  return Math.round(avgOpp + dp(pct));
}

// ── RATING YA KWANZA ────────────────────────────────────────────────────
// Haitolewi bure. Unaipata baada ya michezo 5 dhidi ya waliopimwa.
// Ukipata 0% kwenye michezo yote, bado hupati rating — unaendelea
// kujenga kwenye tukio lijalo (michezo inabaki kwenye rekodi).
export function initialRating(games) {
  if (games.length < MIN_GAMES_FOR_RATING) {
    return { established: false, reason: `Anahitaji michezo ${MIN_GAMES_FOR_RATING - games.length} zaidi` };
  }
  const pts = games.reduce((a, g) => a + g.score, 0);
  if (pts === 0) {
    return { established: false, reason: 'Hakuna pointi bado — rating haitolewi kwa 0%' };
  }
  const rating = Math.max(IFR_FLOOR, performanceRating(games));
  return { established: true, rating };
}

// ── NORM ────────────────────────────────────────────────────────────────
// Norm ni ushahidi kwamba ulicheza kwa kiwango cha title kwenye tukio
// MOJA — si kwa bahati, si kwa kucheza na wadogo.
export const NORM_RULES = {
  minGames: 5,
  minDistinctOpponents: 3,
  minOtherClubOpponents: 1,
  avgOpponentBelowTarget: 200, // wastani wa wapinzani usishuke chini ya (lengo - 200)
};

export function checkNorm({ games, targetRating, normPerformance, playerClubId }) {
  const reasons = [];
  if (games.length < NORM_RULES.minGames) {
    reasons.push(`Michezo ${games.length}/${NORM_RULES.minGames}`);
  }
  const distinct = new Set(games.map(g => g.opponentId)).size;
  if (distinct < NORM_RULES.minDistinctOpponents) {
    reasons.push(`Wapinzani tofauti ${distinct}/${NORM_RULES.minDistinctOpponents}`);
  }
  const outside = games.filter(g => g.opponentClubId && g.opponentClubId !== playerClubId).length;
  if (outside < NORM_RULES.minOtherClubOpponents) {
    reasons.push(`Wapinzani wa club nyingine ${outside}/${NORM_RULES.minOtherClubOpponents}`);
  }
  const avgOpp = games.length
    ? Math.round(games.reduce((a, g) => a + g.opponentRating, 0) / games.length)
    : 0;
  const minAvg = targetRating - NORM_RULES.avgOpponentBelowTarget;
  if (avgOpp < minAvg) {
    reasons.push(`Wastani wa wapinzani ${avgOpp} (unahitajika ${minAvg})`);
  }
  const perf = performanceRating(games);
  if (perf === null || perf < normPerformance) {
    reasons.push(`Performance ${perf ?? '–'} (unahitajika ${normPerformance})`);
  }

  return {
    achieved: reasons.length === 0,
    performance: perf,
    avgOpponent: avgOpp,
    distinctOpponents: distinct,
    outsideClub: outside,
    reasons,
  };
}

// ── VIPINDI VYA RATING (rating periods) ─────────────────────────────────
// Kila mwezi ni kipindi kimoja. Rating mpya inachapishwa tarehe 1.
export function periodKeyOf(date = new Date()) {
  const d = date instanceof Date ? date : new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

const MONTHS_SW = [
  'Januari', 'Februari', 'Machi', 'Aprili', 'Mei', 'Juni',
  'Julai', 'Agosti', 'Septemba', 'Oktoba', 'Novemba', 'Desemba',
];

export function periodLabel(key) {
  if (!key) return '—';
  const [y, m] = key.split('-').map(Number);
  return `${MONTHS_SW[m - 1]} ${y}`;
}

export function previousPeriod(key) {
  const [y, m] = key.split('-').map(Number);
  return m === 1 ? `${y - 1}-12` : `${y}-${String(m - 1).padStart(2, '0')}`;
}

// ── UHAI (activity) ─────────────────────────────────────────────────────
// Asiyecheza mchezo rasmi kwa miezi 12 anawekwa "hana shughuli".
// Rating yake HAIFUTWI wala haishuki — inahifadhiwa tu.
export const INACTIVE_AFTER_MONTHS = 12;

export function isActive(lastActivePeriod, currentPeriod = periodKeyOf()) {
  if (!lastActivePeriod) return false;
  const [ly, lm] = lastActivePeriod.split('-').map(Number);
  const [cy, cm] = currentPeriod.split('-').map(Number);
  return (cy * 12 + cm) - (ly * 12 + lm) < INACTIVE_AFTER_MONTHS;
}

// ── Umri kutokana na tarehe ya kuzaliwa ─────────────────────────────────
export function ageFrom(dob) {
  if (!dob) return null;
  const d = new Date(dob);
  if (isNaN(d)) return null;
  const diff = Date.now() - d.getTime();
  return Math.floor(diff / (365.25 * 24 * 3600 * 1000));
}

export function scoreFromResult(result, color) {
  if (result === '½-½') return 0.5;
  if (result === '1-0') return color === 'white' ? 1 : 0;
  if (result === '0-1') return color === 'white' ? 0 : 1;
  return null;
}
